import {getCookie} from '../../getCookie';
import {COOKIE_VALUE, EXTRA_URL_COOKIE_KEY} from 'general/constants';
import type {ExtraUrlDataCookieParsedType, ExtraUrlDataType} from 'types/extraUrlData';
import {customer as customerStore} from 'general/store';
import {get} from 'svelte/store';
import {isLoggedInViaGoogle} from 'general/libs/isLoggedInViaGoogle';

export const isCrawler = () => {
    const userAgent = window?.navigator?.userAgent || '';
    const numberPagesViewed = Number(getCookie('picreel_tracker__page_views')) || 0;

    return (
        /bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(userAgent) && numberPagesViewed <= 1
    );
};

export const getIsSubscribed = (): string => {
    if (isLoggedInViaGoogle()) {
        return get(customerStore).email ? 'true' : '';
    }
    return String(getCookie(COOKIE_VALUE.SUBSCRIBER) || '');
};

export const setPageAttributes = () => ({
    isSubscribed: getIsSubscribed(),
    isPhoneSubscribed: String(getCookie(COOKIE_VALUE.SUBSCRIBER_PHONE) || ''),
    isFirstDaySubscriber: String(getCookie(COOKIE_VALUE.IS_FIRST_DAY_SUBSCRIBER) || ''),
    isExitShowed: String(getCookie(COOKIE_VALUE.IS_EXIT_SHOW) || ''),
    isCrawler: String(isCrawler() || ''),
    pageViews: String(Number(getCookie('picreel_tracker__page_views')) || 0),
    realIp: String(getCookie('realIp') || ''),
    isLoggedIn: String(get(customerStore).isLoggedIn || ''),
});

export const getExtraUrlData = (): ExtraUrlDataType => {
    const extraUrlCookie = getCookie(EXTRA_URL_COOKIE_KEY);
    if (!extraUrlCookie) return {} as ExtraUrlDataType;

    const extraUrlCookieParsed = JSON.parse(
        decodeURIComponent(extraUrlCookie),
    ) as ExtraUrlDataCookieParsedType;

    return {
        utmSource: extraUrlCookieParsed?.utm_source,
        utmMedium: extraUrlCookieParsed?.utm_medium,
        utmCampaign: extraUrlCookieParsed?.utm_campaign,
        utmContent: extraUrlCookieParsed?.utm_content,
        utmTerm: extraUrlCookieParsed?.utm_term,
        referral: extraUrlCookieParsed?.referral,
        keyword: extraUrlCookieParsed?.keyword,
    };
};

/**
 * Retrieves the remote IP address from the 'realIp' cookie.
 * @returns {string} The remote IP address or an empty string if the cookie is not set.
 */
export const getRemoteIp = (): string => getCookie('realIp') || '';

/**
 * Retrieves the current timezone offset in minutes as a string.
 *
 * @returns {string} The current timezone offset in minutes.
 */
export const getTimezone = (): string => new Date().getTimezoneOffset().toString();
